import _ from "lodash"

export const fixEmptyObjectsInSubElements = (item: { [key: string]: any | any[] }) => {
    for (const [key, value] of Object.entries(item)) {
        try {
            if (typeof value === 'object' && _.isEmpty(value)) {
                _.set(item, key, null)
            } else if (Array.isArray(value)) {
                const newArray = value.filter(e => e !== undefined)
                newArray.forEach(e => fixEmptyObjectsInSubElements(e))
                newArray.forEach(e => fixEmptyObjectsInSubElements(e))
                _.set(item, key, newArray.filter(o => !(typeof o === 'object' && o !== null && _.isEmpty(o))))
            } else if (typeof value === 'object' && value !== null) {
                fixEmptyObjectsInSubElements(value)
            }
        } catch(err) {
            // logger (indicate that it happened in fixEmptyObjectsInSubElements)
            throw err
        }
    }
}

export const mergeOverridingArrays = (baseObject: Object, updates: Object) => {
    const util = (baseValue, updatedValue) => {
        if(_.isArray(baseValue) && _.isArray(updatedValue)) {
            return updatedValue
        }
    }

    return _.mergeWith(baseObject, updates, util)
}
    